/**
 * Постраничная навигация списка дел. Живёт в `.totals-row` — в макете это подвал блока
 * со сводкой; кнопки — обычные `.act-btn`, размер страницы — `.act-select`.
 * Инлайновый `display:flex` на правой половине повторяет приём макета
 * (`.section-title-row` → `<span style="display:flex;gap:12px;align-items:center;flex-wrap:wrap">`).
 */
import type { ReactNode } from 'react';
import { caseWord } from '@/lib/format';

export const PAGE_SIZES: readonly number[] = [25, 50, 100];

export interface PaginationProps {
    page: number;
    limit: number;
    total: number;
    pages: number;
    onPage: (page: number) => void;
    onLimit?: (limit: number) => void;
    /** Левая половина строки; по умолчанию — «Показано X–Y из N дел». */
    left?: ReactNode;
}

export function Pagination({ page, limit, total, pages, onPage, onLimit, left }: PaginationProps) {
    const lastPage = Math.max(1, pages);
    const current = Math.min(Math.max(page, 1), lastPage);
    const first = total === 0 ? 0 : (current - 1) * limit + 1;
    const last = Math.min(current * limit, total);

    const summary =
        left ??
        (total === 0 ? (
            <span>Дел нет</span>
        ) : (
            <span>
                Показано{' '}
                <b>
                    {first}–{last}
                </b>{' '}
                из <b>{total}</b> {caseWord(total)}
            </span>
        ));

    return (
        <div className="totals-row">
            {summary}
            <span style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                {onLimit ? (
                    <select
                        className="act-select"
                        aria-label="Дел на странице"
                        value={String(limit)}
                        onChange={(event) => onLimit(Number(event.target.value))}
                    >
                        {PAGE_SIZES.map((size) => (
                            <option key={size} value={String(size)}>
                                по {size}
                            </option>
                        ))}
                    </select>
                ) : null}
                <button
                    type="button"
                    className="act-btn"
                    disabled={current <= 1}
                    onClick={() => onPage(current - 1)}
                >
                    ← Назад
                </button>
                <span>
                    Стр. <b>{current}</b> из <b>{lastPage}</b>
                </span>
                <button
                    type="button"
                    className="act-btn"
                    disabled={current >= lastPage}
                    onClick={() => onPage(current + 1)}
                >
                    Вперёд →
                </button>
            </span>
        </div>
    );
}

export default Pagination;
